export const INVOICE_DATA_ALL_RECORDS_REQUEST = 'INVOICE_DATA_ALL_RECORDS_REQUEST';
export const INVOICE_DATA_ALL_RECORDS_SUCCESS = 'INVOICE_DATA_ALL_RECORDS_SUCCESS';
export const INVOICE_DATA_ALL_RECORDS_FAIL = 'INVOICE_DATA_ALL_RECORDS_FAIL';

export const INVOICE_DATA_CREATE_REQUEST = 'INVOICE_DATA_CREATE_REQUEST';
export const INVOICE_DATA_CREATE_SUCCESS = 'INVOICE_DATA_CREATE_SUCCESS';
export const INVOICE_DATA_CREATE_FAIL = 'INVOICE_DATA_CREATE_FAIL';
export const INVOICE_DATA_CREATE_RESET = 'INVOICE_DATA_CREATE_RESET';

export const INVOICE_DATA_UPDATE_REQUEST = 'INVOICE_DATA_UPDATE_REQUEST';
export const INVOICE_DATA_UPDATE_SUCCESS = 'INVOICE_DATA_UPDATE_SUCCESS';
export const INVOICE_DATA_UPDATE_FAIL = 'INVOICE_DATA_UPDATE_FAIL';
export const INVOICE_DATA_UPDATE_RESET = 'INVOICE_DATA_UPDATE_RESET';

export const INVOICE_DATA_DELETE_REQUEST = 'INVOICE_DATA_DELETE_REQUEST';
export const INVOICE_DATA_DELETE_SUCCESS = 'INVOICE_DATA_DELETE_SUCCESS';
export const INVOICE_DATA_DELETE_FAIL = 'INVOICE_DATA_DELETE_FAIL';
export const INVOICE_DATA_DELETE_RESET = 'INVOICE_DATA_DELETE_RESET';
